import { render } from "./Callback.vue?vue&type=template&id=157db454"
import script from "./Callback.vue?vue&type=script&lang=js"
export * from "./Callback.vue?vue&type=script&lang=js"
script.render = render

export default script